<template>
	<div v-if="message" class="notification c-basket-message" :style="customStyles" data-testid="notification">
		<DsIcon
			class="c-basket-message__icon"
			:icon-name="icon"
			:size="currentIconSize" />
		<DsText class="c-basket-message__description">
			<span v-html="message"></span>
		</DsText>
	</div>
</template>

<script setup lang="ts">
import { DsIcon, DsText, dsUseIsMobile } from '@coloplast/design-system';
import type { IconSize, IconName } from '@coloplast/design-system/types/components/icon/interface.d.ts';
import { toRefs, computed, type ComputedRef } from 'vue';

const DEFAULT_MOBILE_ICON_SIZE: IconSize  = 'md';
const DEFAULT_DESKTOP_ICON_SIZE: IconSize = 'lg';
const DEFAULT_ICON_NAME: IconName = 'information-circle';

interface Props {
	message?: string;
	iconName?: IconName;
	iconSizes?: [IconSize, IconSize];
	bgColor?: string;
}

const props = defineProps<Props>();

const { isMobile } = dsUseIsMobile();

const customStyles = computed(() => {
	if (typeof props.bgColor === 'undefined') return;

	return {
		backgroundColor: `var(--ds-color-bg-${props.bgColor}`
	}
});

const { message, iconName, iconSizes } = toRefs(props);
const icon =  computed(() => iconName?.value || DEFAULT_ICON_NAME )
const currentIconSize: ComputedRef<IconSize> = computed(() => {
	const sizes = iconSizes?.value || [DEFAULT_MOBILE_ICON_SIZE, DEFAULT_DESKTOP_ICON_SIZE]

	return isMobile.value
		? sizes[0]
		: sizes[1]
})
</script>

<style scoped lang="scss">
@import 'multisite/styles/settings/settings';
@import 'multisite/styles/tools/tools';

.c-basket-message p {
	margin-top: ds-space(2);
}

.notification.c-basket-message {
	margin: ds-space(5) 0;

	&:first-child {
		margin-top: ds-space(8);
	}
}

</style>
